var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#01824c",
    fillRule: "evenodd",
    d: "M64 108.48c24.564 0 44.477-19.913 44.477-44.478 0-24.564-19.913-44.477-44.477-44.477-24.565 0-44.478 19.913-44.478 44.477 0 24.565 19.913 44.478 44.478 44.478m.191-66.714c-3.571 0-8.514 2.043-11.04 4.562l-6.858 6.843H80.48l11.431-11.405zM74.79 81.682c-2.526 2.52-7.468 4.562-11.04 4.562H36.03L47.461 74.84h34.187zM85.9 58.873H40.59l-2.14 2.139c-5.069 4.561-3.566 8.125 3.532 8.125h45.433L89.556 67c5.02-4.535 3.442-8.126-3.655-8.126z",
    className: "icon_svg__black",
    clipRule: "evenodd"
  })));
};
export default SvgIcon;